import React from "react";

const AttentionCheck = ({ question, value, onChange }) => {
  const { questionId, options = [], scale } = question;

  // Attention checks can be rendered as either single_choice options or likert scale
  if (options.length > 0) {
    return (
      <div className="space-y-2">
        {options.map((option) => (
          <button
            key={option.value}
            onClick={() => onChange(questionId, option.value)}
            className={`w-full text-left px-4 py-3 rounded-lg transition-all border ${
              value === option.value
                ? "bg-spiders-primary-500/10 border-spiders-primary-500 text-spiders-text-primary"
                : "bg-spiders-bg-elevated border-transparent text-spiders-text-secondary hover:bg-spiders-bg-light"
            }`}
          >
            <div className="flex items-center gap-3">
              <div
                className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                  value === option.value
                    ? "border-spiders-primary-500"
                    : "border-spiders-text-muted"
                }`}
              >
                {value === option.value && (
                  <div className="w-2 h-2 rounded-full bg-spiders-primary-500" />
                )}
              </div>
              <span className="text-sm">{option.label}</span>
            </div>
          </button>
        ))}
      </div>
    );
  }

  // Likert-style attention check
  if (scale) {
    const points = scale.points || 5;
    const labels = scale.labels || [];

    return (
      <div>
        <div className="flex gap-1.5 justify-center">
          {Array.from({ length: points }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => onChange(questionId, i + 1)}
              className={`flex-1 py-2 px-1 rounded-lg text-center transition-all text-xs font-medium ${
                value === i + 1
                  ? "bg-spiders-primary-500 text-white ring-2 ring-spiders-primary-500/50"
                  : "bg-spiders-bg-elevated text-spiders-text-muted hover:bg-spiders-bg-light"
              }`}
            >
              {labels[i] || i + 1}
            </button>
          ))}
        </div>
        {labels.length >= 2 && (
          <div className="flex justify-between text-[10px] text-spiders-text-muted mt-1 px-1">
            <span>{labels[0]}</span>
            <span>{labels[labels.length - 1]}</span>
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default AttentionCheck;
